import React from "react";

// Secondary Button - Secondary actions
export const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
  className = "",
  type = "button",
  loadingText,
  loading = false,
  icon: Icon,
  size = "md",
  ...props
}) => {
  // Filter out props that shouldn't go to the DOM
  const { loadingText: _, loading: __, icon: ___, ...buttonProps } = props;
  const sizeClass =
    size === "sm"
      ? "px-3 py-2 text-sm"
      : "px-6 py-3";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClass} max-lg:min-h-11 text-brand-charcoal bg-brand-cream font-display font-bold tracking-wide border border-brand-charcoal/20
        rounded-lg
        hover:border-brand-gold-ink hover:text-brand-charcoal
        focus:outline-none focus:ring-2 focus:ring-brand-gold-ink
        transition-colors duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        inline-flex items-center justify-center space-x-2
        ${className}
      `}
      {...buttonProps}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
};

export default SecondaryButton;
